import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SnotifyService } from 'ng-snotify';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { BasicOfInventionDetailsService } from '../_services/basic-of-invention-details.service';
import { BasicInventionDetailsDataForm } from '../_models/basic-invention-details-data-form';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css']
})
export class PreviewComponent implements OnInit {
  previewForm: FormGroup;
  stages: string[] = ['Basic Invention Details', 'Patent Drawing', 'Patent Search', 'Patent Draft'];
  projectId: any;
  userDataSession;
  doingStatusSelected: string = 'Preview';
  projectTitle: String = 'Documents';
  basicInventionDetailsDataForm: BasicInventionDetailsDataForm = new BasicInventionDetailsDataForm();

  constructor(private formBuilder: FormBuilder,
    private snotifyService: SnotifyService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    private router: Router,
    private basicOfInventionDetailsService: BasicOfInventionDetailsService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.projectId = params['id'];
    });
  }

  ngOnInit() {
    this.userDataSession = this.authService.getUserData();
    this.previewForm = this.formBuilder.group({
      projectAccept: false,
    })
    this.getDrawingStatus(this.projectId);
  }

  getBasicInventionPdf(projectId) {
    let newWindow = window.open();
    this.http.get(environment.apiUrl + "/basicInventionDetails/getPdf/" + projectId + '/' + this.userDataSession.userDetailsId + '/' + 6 + '/' + this.authService.getUserToken(), { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        let file = new Blob([blob], { type: 'application/pdf' });
        let url = URL.createObjectURL(file);
        newWindow.location.href = url;
      });
  }

  getPatentDrawingPdf(projectId) {
    let newWindow = window.open();
    this.http.get(environment.apiUrl + "/patentDrawing/getPdf/" + projectId + '/' + this.userDataSession.userDetailsId + '/' + 7 + '/' + this.authService.getUserToken(), { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        let file = new Blob([blob], { type: 'application/pdf' });
        let url = URL.createObjectURL(file);
        newWindow.location.href = url;
      });
  }

  getPatentSearchPdf(projectId) {
    let newWindow = window.open();
    this.http.get(environment.apiUrl + "/patentsearch/getPdf/" + projectId + '/' + this.userDataSession.userDetailsId + '/' + 8 + '/' + this.authService.getUserToken(), { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        let file = new Blob([blob], { type: 'application/pdf' });
        let url = URL.createObjectURL(file);
        newWindow.location.href = url;
      });
  }

  getPatentDraftPdf(projectId) {
    let newWindow = window.open();
    this.http.get(environment.apiUrl + "/patentDraft/getPdf/" + projectId + '/' + this.userDataSession.userDetailsId + '/' + 9 + '/' + this.authService.getUserToken(), { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        let file = new Blob([blob], { type: 'application/pdf' });
        let url = URL.createObjectURL(file);
        newWindow.location.href = url;
      });
  }

  goToBasicInventionDetails(projectId) {
    this.router.navigate(['/main/basicInventionDetails', projectId])
  }

  goToPatentSearch(projectId) {
    this.router.navigate(['/main/patentSearch', projectId])
  }

  goToPatentDraft(projectId) {
    this.router.navigate(['/main/patentDraft', projectId])
  }
  goToPatentDrawing(projectId) {
    this.router.navigate(['/main/patentDrawing', projectId])
  }

  formSubmit() {
    this.spinnerService.show();
    this.http.post(environment.apiUrl + "/preview/previewDocumentSubmit/" + this.userDataSession.userDetailsId + '/' + this.projectId + '/' + this.authService.getUserToken(), {})
      .subscribe(resp => {
        this.spinnerService.hide();
        this.snotifyService.success("You have submitted the documents successfully and further details has been mailed",{
          timeout: 0,
          showProgressBar: false,
          closeOnClick: true,
        })
      }, error => {
        this.spinnerService.hide();
        console.log(error);
      })
  }

  getDrawingStatus(projectId) {
    this.basicOfInventionDetailsService.getBasicInventionDetailsByprojectId(projectId).subscribe(
      resp => {
        this.basicInventionDetailsDataForm = resp as BasicInventionDetailsDataForm;
      })
  }
}
